import { html } from 'lit'
import { unsafeHTML } from 'lit/directives/unsafe-html.js';

// Icons
import icon from 'url:./icon.svg'

import { uri } from '../data-util'
import langs from './language.json'
import * as immu from 'object-path-immutable'
import 'view-base/unit-button'
import 'view-base/unit-link'
import { textTable } from './textTable'
import { provider } from './provider'
import * as util from '../view-advice-util'

// ----------------------------------------------
// Creator of text for view adivce and params
// drugs, rules, faqs come as ObjectById
// ----------------------------------------------
export function text( { drugs, rules, faqs } ) {

  const xeon = { drugs, rules, faqs }
  // Ensure language and enable manual override
  const lang = uri.lang()
  const dict = langs[ lang ]
  const data = provider( xeon )

  // Make drugs bold and adverse events red
  const rd = util.replaceDrugs( dict.place1, dict.place2, lang )
  const rn = util.replaceDrugs( dict.place3, dict.place4, lang )
  // Map of drug names
  const ns = Object.values( xeon.drugs ).reduce( ( acc, cur ) => {
    acc[ cur.id ] = cur.name[ lang ]
    return acc
  }, {} )

  // Collect all html templates
  const htmls = []

  // -----------------------------
  // Case: no wirkstoff and abort
  // -----------------------------
  if ( Object.values( drugs ).length == 0 ) {
    return html `
      <div class="box adverse">
        <h2>
          <img src="${icon}" alt="${dict.alt}"/>
          <span>${dict.title}</span>
          <span style="flex:1"></span>
        </h2>
        <p style="margin-top:1.5rem;">${dict.label_nodrug}</p>
      </div>`
  }

  // --------------------------------------------
  // Condition: We always have at least one drug
  // --------------------------------------------
  // Iterate for group of adverse event
  const chapters = data.text( lang ).map( group => {
    const ades = []
    for ( const item of group.items ) {
      // Spacer
      if ( ades.length ) {
        // ades.push( html `<span>, </span>` )
        ades.push( html `<br>` )
      }
      // Adverse event
      if ( item.freq > 1 ) {
        ades.push( html `<span>${util.capitalize(item.text)} (${item.freq}%): <span>` )
      } else {
        ades.push( html `<span>${util.capitalize(item.text)}: <span>` )
      }
      // List of drugs
      ades.push( item.list.map( ( drug, idx, arr ) => {
        if ( idx + 1 < arr.length ) {
          return html `<b class=d>${ns[drug.id]}</b><span>, </span>`
        } else {
          return html `<b class=d>${ns[drug.id]}</b>`
        }
      } ) )
    }
    return html `
      <p>
        <span class="chapter">${dict[group.name]}</span><br>
        ${ ades }
      </p>`
  } )

  // --------------------------------------------------
  // Finalize rendering and join will create space
  // between sentences
  // --------------------------------------------------
  // Header with orange shield each groups is one sentence
  // console.log( "score:", data.score() )
  return html `
    <div class="box adverse">
      <h2>
        <img src="${icon}" alt="${dict.alt}"/>
        <span>${dict.title}</span>
        ${ util.build.up("abridge") }
        <span style="flex:1"></span>
        ${ util.build.hub(`docs/adverse/${lang}`) }
        <span class=bar></span>
        ${ util.build.copy("adverse") }
        <span class=bar></span>
        <span class=score>-${ data.score() }%</span>
      </h2>
      <!-- Table Topten -->
      <section class=wide>${textTable(xeon)}</section>
      <!-- Chapters -->
      ${chapters}
    </div>`
}
